module.exports = __webpack_public_path__ + "static/media/rickandmorty-homepage.538304cb.png";